<div class="p-4">
  <div class="p-4 p-card">
    You don't have access to Referral Dashboard. Please contact Carelon at 1-844-411-9622 and use
    prompts for the Portal support or reach us at
    <a [attr.href]="portalSupportLink" target= "_blank" class="text-primary-400 no-underline">Portal Support</a>.
  </div>
</div>
